import styled from 'styled-components'
import { Card, CardBody } from 'shards-react'

export const CustomizedCard = styled(Card)`
    height: 70vh;

    @media (min-width: 1100px) {
        height: 75vh;
    }
`

export const CustomizedCardBody = styled(CardBody)`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
`
export const ContainerApp = styled.div`
    width: 100px;
    height: 100px;
    border-radius: 8px;
    margin-right: 20px;
    box-shadow: 0px 4px 16px rgba(216, 224, 242, 0.8);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`
export const Icon = styled.span`
    display: inline-block;
    font-size: 35px;
`
export const TitleCard = styled.label`
    margin-top: 10px;
`
